import React from "react";

export default () => {
  return (
    <div className="mx-auto mt-5 loading">
      <span></span>
    </div>
  );
};
